// extracted by mini-css-extract-plugin
export var infoItem = "_tq-2";
export var title = "_tq-0";
export var value = "_tq-1";